import Toastify from 'toastify-js';

import 'toastify-js/src/toastify.css';

export function showToast(message, duration = 3000) {
  Toastify({
    text: message,
    duration,
    close: true,
    gravity: 'top',
    position: 'center',
    stopOnFocus: true,
  }).showToast();
}
